import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'homey-page-title-layout',
  imports: [
    NgClass
  ],
  templateUrl: './page-title-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageTitleLayoutComponent {
  public readonly centered = input(false);
  public readonly atPageTop = input<boolean>(true);
  public readonly subtitle = input<string>();
}
